<template>
    <div id="contactsMain">
        <div class="e-card col-md-12">
            <div class="e-card-header">
                <div class="e-card-header-caption">
                    <div class="e-card-header-title">Formula settings</div>
                </div>
                <br>
            </div>
            <div class="e-card-content">
                <div class="form-row">
                    <div class="form-group col-md-10 d-flex justify-content-center input-group">
                        <ejs-button id="base" style="margin-right:10px" cssClass="e-primary" v-on:click.native='btnBase24Click'>Base24</ejs-button>
                        <!--<ejs-button id="offpeak23" style="margin-right:10px" cssClass="e-info" v-on:click.native='btnOffpeak23Click'>Offpeak23-7</ejs-button>
                        <ejs-button id="peak7" style="margin-right:10px" cssClass="e-info" v-on:click.native='btnPeak7Click'>Peak7-23</ejs-button>-->
                        <ejs-button id="offpeak20" style="margin-right:10px" cssClass="e-primary" v-on:click.native='btnOffpeak20Click'>Offpeak20-8</ejs-button>
                        <ejs-button id="peak8" style="margin-right:10px" cssClass="e-primary" v-on:click.native='btnPeak8Click'>Peak8-20</ejs-button>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-10 d-flex justify-content-center input-group">
                        <ejs-button id="bl" style="margin-right:10px" cssClass="secondary" v-on:click.native='btnBLClick'>BL</ejs-button>
                        <ejs-button id="pl" style="margin-right:10px" cssClass="secondary" v-on:click.native='btnPLClick'>PL</ejs-button>
                    </div>
                </div>
                    <div class="form-row">

                        <div class="form-group col-md-10 d-flex justify-content-center input-group">
                            <ejs-textbox id='formula' name="formula" floatLabelType="Auto" v-model="data.formula" placeholder="Formula"></ejs-textbox>
                        </div>
                        <div class="form-group col-md-2 d-flex justify-content-center input-group">
                            Available operations are + - / * ( )
                        </div>
                    </div>
                    <div class="form-row">
                        <div style="text-align: right; margin-top:20px;" class="form-group col-md-12">
                            <ejs-button style="margin-right:10px" cssClass="e-primary" v-on:click.native='btnSaveClick'>Save</ejs-button>
                            <ejs-button style="margin-right:10px" v-on:click.native='btnResetClick'>Reset</ejs-button>
                        </div>
                    </div>
                </div>

            </div>
        <br>
        <div class="e-card col-md-4">
            <div class="e-card-header">
                <div class="e-card-header-caption">
                    <div class="e-card-header-title">Formula Testing</div>
                </div>
                <br>
            </div>
            <div class="e-card-content">
                <div class="clientButtons">
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <div class="form-group col-md-10 d-flex justify-content-center input-group">
                                <ejs-numerictextbox id='BLtest' name="clickFee" floatLabelType="Auto" v-model="blTestPrice" placeholder="BL test value"></ejs-numerictextbox>
                            </div>
                            <div class="form-group col-md-10 d-flex justify-content-center input-group">
                                <ejs-numerictextbox id='PLtest' name="clickFee" floatLabelType="Auto" v-model="plTestPrice" placeholder="PL test value"></ejs-numerictextbox>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div style="text-align: right; margin-top:20px;" class="form-group col-md-12">
                            <ejs-button cssClass="e-primary" v-on:click.native='btnTestClick'>Test</ejs-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--</div>-->
</template>

<script>
    import Vue from "vue";
    import { CheckBoxPlugin, ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import { DialogPlugin, DialogUtility } from '@syncfusion/ej2-vue-popups';
    import SyncHelper from '../../common/syncfusion'
    import apis from '../../common/network'
    import urls from '../../common/urls';
    import authToken from '../../common/authToken';
    import store from '../../store';
    import router from '../../router/index';


    Vue.use(DialogPlugin);
    Vue.use(ButtonPlugin);
    Vue.use(DialogUtility);

    export default {
        mounted() {
            document.getElementById('base').setAttribute('title', 'Total number of hours in one year. Use in formula: [Base24]');
            //document.getElementById('offpeak23').setAttribute('title', 'Off-Peak hours which are defined as weekdays from Monday to Friday from 23:00 hours to 07:00 hours. Use in formula: [OffPeak23]');
            //document.getElementById('peak7').setAttribute('title', 'Peak hours which are defined as weekdays from Monday to Friday from 07:00 hours to 23:00 hours. Use in formula: [Peak7]');
            document.getElementById('offpeak20').setAttribute('title', 'Off-Peak hours which are defined as weekdays from Monday to Friday from 20:00 hours to 08:00 hours. Use in formula: [Offpeak20]');
            document.getElementById('peak8').setAttribute('title', 'Peak hours which are defined as weekdays from Monday to Friday from 08:00 hours to 20:00 hours. Use in formula: [Peak8]');
            document.getElementById('bl').setAttribute('title', 'BL corresponding to the traded price of the Baseload product for the selected country. Use in formula: [BL]');
            document.getElementById('pl').setAttribute('title', 'PL corresponding to the traded price of the Peakload product for the selected country. Use in formula: [PL]');
        },
        created() {
            apis.protectedApi(`OffPeakPrice/${store.state.selectedContractId}`)
                .then(response => {
                    this.data = response.data.result;
                }).catch(e => {
                    if (e.response) {
                        this.showErrorDialog(e.response.data.message);
                    }
                })
        },
        data() {
            return {
                data: {},
                plTestPrice: 1,
                blTestPrice: 1,
                store: store,
            }
        },
        methods: {
            btnSaveClick: function (e) {
                e.preventDefault();
                //this.data.stateId = this.preStateId;
                if (!this.data.id) {
                    apis.protectedApi.post(`OffPeakPrice`, this.data)
                        .then(response => {
                            this.data = response.data.result;
                            let message = { title: 'Success!', content: 'Formula saved successfully', cssClass: 'e-toast-success' };
                            this.$emit('showToast', message);
                            this.showInformationDialog(message.content);
                        }).catch(e => {
                            if (e.response) {
                                this.showErrorDialog(e.response.data.message);
                            }
                        });
                }
                else {
                    apis.protectedApi.put(`OffPeakPrice`, this.data)
                        .then(response => {
                            this.data = response.data.result;
                            let message = { title: 'Success!', content: 'Formula updated successfully', cssClass: 'e-toast-success' };
                            this.$emit('showToast', message);
                            this.showInformationDialog(message.content);
                        }).catch(e => {
                            if (e.response) {
                                this.showErrorDialog(e.response.data.message);
                            }
                        });
                }

            },
            btnResetClick: function (e) {
                apis.protectedApi(`OffPeakPrice/${store.state.selectedContractId}`)
                .then(response => {
                    this.data = response.data.result;
                }).catch(e => {
                    if (e.response) {
                        this.showErrorDialog(e.response.data.message);
                    }
                })
            },
            btnTestClick: function (e) {
                var formula = this.data.formula;
                var bl = this.blTestPrice;
                var pl = this.plTestPrice;
                apis.protectedApi.post(`OffPeakPrice/EvaluateFormula`, { formula, bl, pl })
                    .then(response => {
                        if (response.data.canRun) {
                            this.showInformationDialog("Formula evaluation for entered BL and PL based on current year would be: <b>" + response.data.result +"</b>");
                        }
                        else {
                            this.showErrorDialog("Invalid formula, cant run evaluation. Please change and test again!")
                        }
                }).catch(e => {
                    if (e.response) {
                        this.showErrorDialog(e.response.data.message);
                    }
                })
            },
            btnBase24Click: function (e) {
                this.data.formula = this.data.formula + "[Base24]";
            },
            btnPeak8Click: function (e) {
                this.data.formula = this.data.formula + "[Peak8]";
            },
            //btnPeak7Click: function (e) {
            //    this.data.formula = this.data.formula + "[Peak7]";
            //},
            btnOffpeak20Click: function (e) {
                this.data.formula = this.data.formula + "[Offpeak20]";
            },
            //btnOffpeak23Click: function (e) {
            //    this.data.formula = this.data.formula + "[Offpeak23]";
            //},
            btnBLClick: function (e) {
                this.data.formula = this.data.formula + "[BL]";
            },
            btnPLClick: function (e) {
                this.data.formula = this.data.formula + "[PL]";
            },

            showErrorDialog: function (message) {
                DialogUtility.alert({
                    title: 'Error',
                    content: message,
                    position: { X: 700, Y: 200 },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' },
                    zIndex: 1100
                });
            },
            showInformationDialog: function (message) {
                DialogUtility.alert({
                    title: 'Info',
                    content: message,
                    position: { X: 700, Y: 200 },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' },
                    zIndex: 1100
                });
            }
        },
    }

</script>

<style>
</style>